export const PREVIEW_VALUE = 1245532.36;
export const DEFAULT_PRESET = `#`;
export const CUSTOM_PRESET = `Custom`;
export const PREFIX_PRESETS = [`$`];
export const SUFFIX_PRESETS = [`%`];
export const ALL_PRESETS = [...PREFIX_PRESETS, ...SUFFIX_PRESETS, DEFAULT_PRESET, CUSTOM_PRESET];
export const AXIS_UNIT_PRECISION_MIN = 0;
export const AXIS_UNIT_PRECISION_MAX = 8;
